import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

@Injectable({ providedIn: 'root' })
export class AuthTokenService {
  private readonly localStorage = inject(LocalStorageService);

  getAccessToken(): string | null {
    return this.localStorage.get<string>(ACCESS_TOKEN_KEY);
  }

  getRefreshToken(): string | null {
    return this.localStorage.get<string>(REFRESH_TOKEN_KEY);
  }

  setTokens(accessToken: string, refreshToken: string): void {
    this.localStorage.set(ACCESS_TOKEN_KEY, accessToken);
    this.localStorage.set(REFRESH_TOKEN_KEY, refreshToken);
  }

  setAccessToken(accessToken: string): void {
    this.localStorage.set(ACCESS_TOKEN_KEY, accessToken);
  }

  clearTokens(): void {
    this.localStorage.remove(ACCESS_TOKEN_KEY);
    this.localStorage.remove(REFRESH_TOKEN_KEY);
  }

  hasTokens(): boolean {
    return !!this.getAccessToken();
  }
}
